<template>
  <div class="container-fluid">
    <!-- ENCABEZADO -->
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">
            Detalle de imputación<span v-if="allocation"> #{{ allocation.id }}</span>
          </h1>
          <p v-if="allocation" class="view-header__subtitle">
            <span v-if="provider">{{ provider }}</span>
            <span v-if="allocation.created_at"> · {{ formatoDate2Fecha(allocation.created_at) }}</span>
          </p>
        </div>
        <div class="view-header__actions">
          <DownloadDoc :pdfurl="pdfurl" :open="false" :filename="'a.pdf'">
            <button type="button" class="btn view-header__btn">
              <i class="bi bi-download"></i>
              Descargar
            </button>
          </DownloadDoc>
          <DownloadDoc :pdfurl="pdfurl" :open="true" :filename="'a.pdf'">
            <button type="button" class="btn view-header__btn view-header__btn--primary">
              <i class="bi bi-printer"></i>
              Imprimir
            </button>
          </DownloadDoc>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- COMPRAS -->
      <div class="col-md-6">
        <div class="filters-panel__section-title">
          <i class="bi bi-cart"></i>
          Compras imputadas
        </div>
        <div class="data-table">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Número</th>
                  <th class="text-right">Importe</th>
                  <th class="text-right">En Recibo</th>
                  <th class="text-center">Detalle</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isBusy">
                  <td colspan="5" class="data-table__empty">Cargando…</td>
                </tr>
                <tr v-else-if="!purchases.length">
                  <td colspan="5" class="data-table__empty">Sin compras imputadas</td>
                </tr>
                <tr v-for="(item, idx) in purchases" v-else :key="'p-' + idx">
                  <td>{{ item.type }}</td>
                  <td>{{ item.number }}</td>
                  <td class="text-right">{{ item.amount }}</td>
                  <td class="text-right">{{ item.pivot && item.pivot.partial }}</td>
                  <td class="text-center">
                    <a
                      :href="`/compras/index/detalle/${item.purchase && item.purchase.id}`"
                      class="table-action-btn"
                      title="Ver detalle"
                    >
                      <i class="bi bi-eye"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- PAGOS -->
      <div class="col-md-6">
        <div class="filters-panel__section-title">
          <i class="bi bi-cash-stack"></i>
          Órdenes de pago / Retenciones
        </div>
        <div class="data-table">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Tipo</th>
                  <th>Número</th>
                  <th class="text-right">Importe</th>
                  <th class="text-right">Imputado</th>
                  <th class="text-center">Detalle</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="isBusy">
                  <td colspan="6" class="data-table__empty">Cargando…</td>
                </tr>
                <tr v-else-if="!payments.length">
                  <td colspan="6" class="data-table__empty">Sin pagos imputados</td>
                </tr>
                <tr v-for="(item, idx) in payments" v-else :key="'pay-' + idx">
                  <td>{{ item.created_at }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.number }}</td>
                  <td class="text-right">{{ item.amount }}</td>
                  <td class="text-right">{{ item.pivot && item.pivot.partial }}</td>
                  <td class="text-center">
                    <router-link
                      v-if="item.payorder_id"
                      :to="`/compras/detalle-orden-de-pago/${item.payorder_id}`"
                      class="table-action-btn"
                      title="Ver detalle"
                    >
                      <i class="bi bi-eye"></i>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DownloadDoc from "../../global/DownloadDoc";
import formatDateMixin from "../../../mixins/formatDateMixin";

export default {
  components: {
    DownloadDoc
  },
  props: ['allocationId'],
  mixins: [formatDateMixin],

  data() {
    return {
      showModal: false,
      showModalRet: false,
      pdfurl: process.env.VUE_APP_BASE_URL+'/api/collections/locPDF/' + 5,
      allocation: null,
      allocationDetails:[],
      purchases:[],
      payments:[],
      provider: null,
      purchasesFields: [
          {
            key: 'type',
            label: 'Tipo',
            sortable: true
          },
          {
            key: 'number',
            label: 'Numero',
            sortable: false
          },
          {
            key: 'amount',
            label: 'Importe',
            sortable: true,
            // Variant applies to the whole column, including the header and footer
            variant: 'danger'
          },
          {
            key: 'pivot.partial',
            label: 'En Recibo',
            sortable: true,
            // Variant applies to the whole column, including the header and footer
            variant: 'danger'
          }
          ,
          {
            key: 'purchase.id',
            label: 'Ver Detalle',
            sortable: true,
            // Variant applies to the whole column, including the header and footer
            variant: 'danger'
          }
      ],
      paymentsFields: [
          {
            key: 'created_at',
            label: 'Fecha',
            sortable: true
          },
          {
            key: 'type',
            label: 'Tipo',
            sortable: true
          },
          {
            key: 'number',
            label: 'Numero',
            sortable: false
          },
          {
            key: 'amount',
            label: 'Importe',
            sortable: true,
            variant: 'danger'
          },
          {
            key: 'pivot.partial',
            label: 'Imputado',
            sortable: true,
            variant: 'danger'
          }
          ,
          {
            key: 'payorder_id',
            label: 'Ver Detalle',
            sortable: true,
            variant: 'danger'
          }
      ],
    }
  },
  computed:{
    isBusy() { return this.allocation == '' }
  },
  methods: {
    getDetailTotal(type) { 
      return this.receiptDetails.filter(d => d.type == type)
        .reduce((accumulator, object) => { return accumulator + object.amount; }, 0);
    },
    getAllocationDetail() {
      var vm = this;
      axios.get('/api/payments/getAllocationDetail/' + this.allocationId)
      .then(response => {
        if(response.data.success) {

          vm.allocation = response.data.data.allocation;
          vm.purchases = response.data.data.purchases;
          vm.purchases.forEach(element => {
              element.type = element.purchase.type + '-' + element.purchase.letter;
              element.number = element.purchase.pos + '-' + element.purchase.number;
          });

          vm.payments =  response.data.data.payorders;
          vm.payments.forEach(element => {
              element.type = element.payorder_id != null? 'OP': 'RT';
              element.number = element.payorder_id != null? element.payorder.number: element.withholding.number;
          });
        }
        axios.get('/api/providers/getProvider/'+ vm.allocation.provider_id)
        .then(res => {
          vm.provider = res.data.data.name;
        })
      })
      .catch(error => {
        alert(error);
      })
    },
  },
  mounted() {
    this.getAllocationDetail();
  }
}
</script>
<style>

.btn-orange {
    background: #f5c05d;
    background: -ms-linear-gradient(top, #f5c05d 0%, #F2AB27 100%);
    background: linear, to bottom, #f5c05d 0%, #F2AB27 100%;
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$from', endColorstr='#ffffff',GradientType=0 );
    color: #fff;
    text-shadow: 0px 0px 2px #e4931b;
    border: 1px solid #F2AB27;
    border-bottom: 1px solid #e4931b;
}
</style>

<style lang="css">
    .fix-footer {
      padding-bottom: 100px;
    }
    .receipt-footer {
      position: fixed;
      bottom:0;
      left:0;
      z-index:100;
      background:rgb(242, 244, 247,0.5);
      border-top: 1px solid #4477BD;
      text-align: right;
      padding:20px;
      width: 100%;
    }
    .totals {
      margin-bottom: 0;
    }
    
    .totals li {
      border-bottom:1px solid var(--border);
      padding:10px 0;
      font-size: 1.75rem;
    }
    
    .totals li:first-child {
      padding-top:0;
    }
    
    .totals li:last-child {
      border-bottom:0;
      padding-bottom:0;
    }
    
    .totals li .form-group .input-group .input-group-addon {
      padding:0 12px;
      background:var(--surface);
      border-radius: 0px;
      border-left:0;
      border-top:0;
    }

    .totals li .form-group .input-group input {
      border-radius:0px;
      border-right: 0;
      border-top:0;
      background: var(--surface);
      height: 20px;
    }
    
    .affix {
      margin-right:15px;
    }
    
    
    </style>
